import { useState } from 'react';
import { SCALES } from '@/lib/scales';

const CUSTOM_KEY = 'tuner.customScales';
const SELECTED_KEY = 'tuner.scale';
const loadCustom = () => { try { return JSON.parse(localStorage.getItem(CUSTOM_KEY) || '[]'); } catch { return []; } };

export function useScales() {
  const [custom, setCustom] = useState(loadCustom);
  const [selectedId, setSelectedId] = useState(() => localStorage.getItem(SELECTED_KEY) || 'off');

  const persist = (list) => { setCustom(list); localStorage.setItem(CUSTOM_KEY, JSON.stringify(list)); };
  const select = (id) => { setSelectedId(id); localStorage.setItem(SELECTED_KEY, id); };

  const save = (scale) => {
    const id = scale.id || `custom-${Date.now()}`;
    const entry = { ...scale, id, custom: true };
    persist(custom.some((s) => s.id === id) ? custom.map((s) => (s.id === id ? entry : s)) : [...custom, entry]);
    select(id);
  };

  const remove = (id) => {
    persist(custom.filter((s) => s.id !== id));
    if (selectedId === id) select('off');
  };

  // Adds a shared scale unless an identical one exists; selects it.
  const importScale = ({ name, steps }) => {
    const builtin = SCALES.find((s) => s.name === name && s.steps.join() === steps.join());
    if (builtin) return select(builtin.id);
    const existing = custom.find((s) => s.name === name && s.steps.join() === steps.join());
    if (existing) return select(existing.id);
    return save({ name, steps });
  };

  const scale = [...SCALES, ...custom].find((s) => s.id === selectedId) || null;
  return { custom, scale, selectedId, select, save, remove, importScale };
}
